import { UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';

import { HomeConfig, InitialState } from '@core/domain/state/core.state';
import { getCountryLangPageHelper } from '@core/infrastructure/router/router.helpers';

// #region Private methods
const HOME_IDS: string[] = InitialState.homeConfig.map((home: HomeConfig) => { return home.stringId; });
const PRODUCT_SEO_REGEX = /.*-l(\d{1,8})/;
const PRODUCT_NAME_REGEX = /\/.*\/.*-c(\d{6,7})p(\d{7,8})\.html/;
const PRODUCT_URL_REGEX = /.*c(\d{1,7})p(\d{7,8})\.html/;
const CATEGIRY_SEO_REGEX = /.*-n(\d{1,8})/;
const CATEGORY_URL_REGEX = /.*c(\d{6,8})/;

function matchingRegexCategory(url: UrlSegment[]): boolean {
    if (CATEGORY_URL_REGEX.exec(url[url.length - 1].path) || CATEGIRY_SEO_REGEX.exec(url[url.length - 1].path)) {
        return true;
    }
    return false;
}

function matchingRegexProduct(url: UrlSegment[]): boolean {
    if (
        PRODUCT_NAME_REGEX.exec(url[url.length - 1].path)
        || PRODUCT_URL_REGEX.exec(url[url.length - 1].path)
        || PRODUCT_SEO_REGEX.exec(url[url.length - 1].path)
    ) {
        return true;
    }
    return false;
}

function matchingHome(page: UrlSegment): string {
    let result = 'ItxHomePage';
    // Category match
    const categoryStringId: string = page?.path?.split('-')[1];
    switch (categoryStringId) {
        case HOME_IDS[1]:
            result = 'ItxHomeMenPage';
            break;
        case HOME_IDS[2]:
            result = 'ItxHomeBgPage';
            break;
    }

    // Special cases latest match
    if (page?.path === 'home-men.html') {
        result = 'ItxHomeMenPage';
    }

    return result;
}

function isHomeWomenPage(page: UrlSegment): boolean {
    const havePage: boolean = page?.path && page?.path !== '';
    const isHomeWomen: boolean = !havePage;
    return isHomeWomen;
}

function isHomeMenPage(page: UrlSegment): boolean {
    const categoryPath: string = page?.path?.split('-')[1];
    const isAnyHome: boolean = HOME_IDS?.includes(categoryPath) && categoryPath !== '' || page?.path === 'home-men.html';
    return isAnyHome;
}
// #endregion

export function collectionsMatcher(segments: UrlSegment[], urlSegmentGroup: UrlSegmentGroup): UrlMatchResult {
    const urlAllowed = ['stories', 'runway', 'collection'];
    const urlNotAllowed = ['women-bags'];
    const page = segments[0];
    const hasCollection = urlAllowed.some(allowedPath => page?.path.includes(allowedPath))
        && !urlNotAllowed.some(notAllowedPath => page?.path.includes(notAllowedPath));
    const [country, lang ] = getCountryLangPageHelper(urlSegmentGroup.segments);
    if (hasCollection) {
        const [pageSegment, slugSegment] = segments;
        const pageOfPathSegment = new UrlSegment(pageSegment.path, {});
        const slugOfPathSegment = new UrlSegment(slugSegment.path, {});

        const matcher = {
            consumed: [],
            posParams: {
                page: pageOfPathSegment,
                slug: slugOfPathSegment,
                countryCode: country,
                langCode: lang,
            },
        };
        return matcher;
    }
    return null;
}

export function categoryMatcher(segments: UrlSegment[]): UrlMatchResult {
    if (matchingRegexCategory(segments)) {
        return {
            consumed: segments,
        };
    }
    return null;
}

export function productMatcher(segments: UrlSegment[], urlSegmentGroup: UrlSegmentGroup): UrlMatchResult {
    if (matchingRegexProduct(segments)) {
        const [country, lang ] = getCountryLangPageHelper(urlSegmentGroup.segments);
        return {
            consumed: segments,
            posParams: {
                countryCode: country,
                langCode: lang,
            },
        };
    }
    return null;
}

export function homesWomenMatcher(segments: UrlSegment[]): UrlMatchResult {
    const path = segments[0];

    if (isHomeWomenPage(path)) {
        return {
            consumed: segments,
            posParams: {
                path: path || new UrlSegment('', {}),
                pageName: new UrlSegment(matchingHome(path), {}),
            },
        };
    }
    return null;
}
export function homesMenMatcher(segments: UrlSegment[]): UrlMatchResult {
    const path = segments[0];

    if (isHomeMenPage(path)) {
        return {
            consumed: segments,
            posParams: {
                path: path || new UrlSegment('', {}),
                pageName: new UrlSegment(matchingHome(path), {}),
            },
        };
    }
    return null;
}

export function staticMatcher(segments: UrlSegment[], urlSegmentGroup: UrlSegmentGroup): UrlMatchResult {
    // NOTE: Contactar con tribu Data si se añaden nuevas páginas de CMS para etiquetarlas en analítica (page_title: getPageTypeForCmsPage)
    const urlAllowed = ['help', 'thenow', 'member-get-member', 'company', 'page'];
    const [ country, lang ] = getCountryLangPageHelper(urlSegmentGroup.segments);
    let parentRoute = new UrlSegment(null, {});
    let menu = new UrlSegment(null, {});
    let submenu = new UrlSegment(null, {});
    const replaceUrl = new UrlSegment(null, {});

    const path = segments[0];

    if (urlAllowed.includes(path.path)) {
        parentRoute = path;

        const positionMenu = 1;
        const positionSubmenu = 2;
        if (segments[positionMenu]) {
            menu = segments[positionMenu];
            if (segments[positionSubmenu]) {
                submenu = segments[positionSubmenu];
            }
        }

        return {
            consumed: segments,
            posParams: {
                countryCode: country,
                langCode: lang,
                parentRoute,
                menu,
                submenu,
                replaceUrl,
            },
        };
    }
    return null;
}

export function errorMatcher(url: UrlSegment[]): UrlMatchResult {
    const path = url?.[0]?.path;

    if (path === 'error') {
        const lastSegment = url[url.length - 1];
        return { consumed: [lastSegment] };
    }

    return null;
}
